export default __webpack_public_path__ + "guide--raster-cyclone-debbie-480-8ae0ba0db7273b7a9e1bb9be4678049a.webp";